const deepCompareObjects = (a, b) => {
  if (a === b) {
    return true;
  }

  if (
    a === null ||
    typeof a !== 'object' ||
    b === null ||
    typeof b !== 'object'
  ) {
    return false;
  }

  let propertiesInA = 0;
  let propertiesInB = 0;

  for (let property in a) {
    propertiesInA += 1;
  }
  for (let property in b) {
    propertiesInB += 1;

    if (!(property in a) || !deepCompareObjects(a[property], b[property])) {
      return false;
    }
  }

  return propertiesInA === propertiesInB;
};

export default deepCompareObjects;
